import { render } from "./Gene.vue?vue&type=template&id=158d5422&scoped=true"
import script from "./Gene.vue?vue&type=script&lang=js"
export * from "./Gene.vue?vue&type=script&lang=js"

import "./Gene.vue?vue&type=style&index=0&id=158d5422&scoped=true&lang=css"

import exportComponent from "/home/pdu/dbesslnc2-20251202/dbesslnc2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158d5422"]])

export default __exports__